import type { RoundResult } from '../../core';

export type GameMode = 'VS_CPU' | 'LOCAL_2P';
export type MvpCharacterId = 'sales' | 'developer';

export interface GameSession {
  mode: GameMode;
  p1CharacterId: MvpCharacterId;
  p2CharacterId: MvpCharacterId;
  stageId: 'late-night-office';
  roundResult: RoundResult | null;
  battleSerial: number;
}

export const createGameSession = (): GameSession => ({
  mode: 'VS_CPU', p1CharacterId: 'sales', p2CharacterId: 'developer',
  stageId: 'late-night-office', roundResult: null, battleSerial: 0,
});

export const otherCharacter = (id: MvpCharacterId): MvpCharacterId => id === 'sales' ? 'developer' : 'sales';
